import { s as spacing, m as mobileSpacing } from '../base/spacing-b4d393ed.js';
import { f as fontSizeValues, b as mobileFontSizeValues } from '../base/typography-dd13a6be.js';
import { p as palette } from '../base/color-ec580bc4.js';

const helptipStyles = {
  triggerIcon: {
    size: `${fontSizeValues.mini}px`,
    margin: `0 ${spacing.micro}`,
    padding: `${spacing.none}`,
    color: palette.gray[500],
    hoverColor: palette.gray[700]
  }
};
const mobileHelptipStyles = {
  triggerIcon: {
    mobile: {
      size: `${mobileFontSizeValues.base}px`,
      margin: `0 ${mobileSpacing.micro}`,
      padding: '7px'
    }
  }
};

export { helptipStyles as h, mobileHelptipStyles as m };
//# sourceMappingURL=helptip-9911c1d4.js.map
